import React from 'react';
import { ThemeProvider } from 'styled-components';
import Theme2 from '@panel/commons/lib/theme';

const extendThemeConfig = theme => {
  return { ...theme, ...{ v2: Theme2 } };
};

const ExtendTheme = ({ children }) => {
  return <ThemeProvider theme={extendThemeConfig}>{children}</ThemeProvider>;
};

export default ExtendTheme;
